import { JsonParsingError, Request, Response, Middleware } from "../common";

const ContentType = "content-type";
const ApplicationJson = "application/json";
const TextPlain = "text/plain";
const TextHtml = "text/html";


export class FetchMiddleware implements Middleware {
  async onRequest(req: Request): Promise<Response> {
    const response = await fetch(req.url, {
      method: req.method,
      headers: req.headers,
      body: req.headers?.[ContentType]?.startsWith(ApplicationJson) ? JSON.stringify(req.body) : req.body,
    });
    let body = await response.text();
    const contentType = response.headers.get(ContentType);
    if (body && !contentType?.includes(TextPlain) && !contentType?.includes(TextHtml)) {
      try {
        body = JSON.parse(body);
      }
      catch (error: any) {
        throw new JsonParsingError(body, error);
      }
    }
    return {
      method: req.method,
      url: req.url,
      path: req.path,
      headers: Object.fromEntries(response.headers),
      params: req.params,
      query: req.query,
      body: body,
      statusCode: response.status,
    };
  }
}
